<div class="d-flex">
  <div class="header-btn-lg">
    <div class="widget-content p-0">
      <div class="widget-content-wrapper">
        <div class="widget-content-left">
          <div class="btn-group" ngbDropdown placement="bottom-right">
            <button
              type="button"
              class="btn btn-link p-0 me-2"
              ngbDropdownToggle
            >
              <span>
                <div
                  class="icon-wrapper user-icon icon-wrapper-alt rounded-circle"
                >
                  <img
                    width="42"
                    src="./assets/images/avatars/2.png"
                    alt=""
                    class="rounded-circle"
                  />
                </div>
              </span>
            </button>
            <div
              class="dropdown-menu-md"
              ngbDropdownMenu
              style="box-shadow: -14px 14px 10px rgb(135 135 135 / 50%)"
            >
              <div class="dropdown-menu-header">
                <div
                  class="dropdown-menu-header-inner bg-info"
                  style="background-color: #032d55 !important"
                >
                  <div class="menu-header-image opacity-2 dd-header-bg-6"></div>
                  <div class="menu-header-content text-left">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left user-icon me-3">
                          <img
                            width="42"
                            src="./assets/images/avatars/2.png"
                            alt=""
                            class="rounded-circle"
                          />
                        </div>
                        <div class="widget-content-left"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="scroll-area-xs profile-box">
                <ul class="nav flex-column">
                  <li class="nav-item">
                    <a
                      [routerLink]="['/login']"
                      class="nav-link font-size-sm"
                      >{{ "Form.Login.SIGN_IN" | translate }}</a
                    >
                  </li>
                </ul>
              </div>
              <div class="widget-content-right me-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
